export * from './model.interface';
export * from './serializable.interface';
export * from './base-model';
export * from './relationship';

export * from './models';
export * from './model.factory';


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/models/index.ts